export const defaultProfilePic =
  "https://fishyhub.imgix.net/prod/app-assets/generic/images/fish-dummy-icon.png";
